export default __webpack_public_path__ + "static/media/project1.19b08b18.webp";